import { Component, inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../../services/notification.service';
import { ResponseObject } from '../../../../common/interfaces/global-interfaces';
import { RegistrationService } from '../../../../services/registration.service';
import { AgeRangeTypeChoices, OTPInputObject, ResendOTPMutation } from '../../../../store/entities/uaa/auth-user.model';
import { passwordValidator } from '../../../validators/input-validators';
import { SettingsService } from '../../../../services/settings.service';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent implements OnInit {
  private fb = inject(FormBuilder);
  private registrationService = inject(RegistrationService);
  private notificationService = inject(NotificationService);
  private settingsService = inject(SettingsService);
  registerForm: FormGroup;
  otpForm: FormGroup;
  showOtpForm = false;
  hide = true;
  loading = false;
  loadingOtp = false;
  regComplete = false;
  private otpTime = 5*60; //5 minutes
  otpTimeRemain = this.otpTime;
  intervalTimeOut: any;
  genders = []
  toDate = new Date();
  readonly startDate = new Date(2000, 0, 1);
  readonly AgeRangeArray = Object?.values(AgeRangeTypeChoices);

  ngOnInit() {
    this.registerForm = this.fb.group({
      firstName: [null, Validators.required],
      middleName: [null],
      lastName: [null, Validators.required],
      email: [null, Validators.email],
      gender: [null, Validators.required],
      profilePhone: [null, Validators.required],
      ageGroup: [null, Validators.required],
      password: [null, [Validators.required, Validators.pattern(passwordValidator)]],
      confirmPassword: [null, Validators.required],
    });

    this.otpForm = this.fb.group({
      phoneNumber: [null, Validators.required],
      otp: [null, Validators.required],
    });
  }

  async register (formData: any) {
    this.loading = true;
    formData = {
      ...formData,
      confirmPassword: undefined
    };
    // console.log('formData', formData);
    const response: ResponseObject = await this.registrationService.registerComplainantUser(formData);
    if (response?.status) {
      this.startCounter();
      this.otpForm.patchValue({
        phoneNumber: this.registerForm?.value?.profilePhone
      })
      this.showOtpForm = true;
    } else {
      this.notificationService.errorMessage(response?.message);
    }
    this.loading = false;
  }


  async verifyOtp (formData: OTPInputObject) {
    this.loading = true;
    formData = {
      ...formData,
      otp: Number(formData?.otp)
    };
    const response = await this.registrationService.verifyOtp(formData);
    if (response?.status === true) {
      this.regComplete = true;
      this.notificationService.successMessage(response?.message);
    } else {
      this.notificationService.errorMessage(response?.message);
    }
    this.loading = false;
  }


  async resendOtp () {
    this.loadingOtp = true;
    const phone: string = this.registerForm?.value?.profilePhone;
    const data: ResendOTPMutation = await this.registrationService.resendOtp(phone);
    if (data?.response?.status) {
      this.otpTimeRemain = data?.resendTime;
    } else {
      this.notificationService.errorMessage(data?.response?.message);
    }
    this.loadingOtp = false;
  }

  private startCounter() {
    clearInterval(this.intervalTimeOut);
    this.intervalTimeOut = setInterval(() => {
      if (this.otpTimeRemain > 0) {
        this.otpTimeRemain -= 1;
      }
    }, 1000);
  }

  getMinutes(time: number): string {
    return Math.floor(time / 60).toString().padStart(2, '0');
  }

  getSeconds(time: number): string {
    return (time % 60).toString().padStart(2, '0');
  }

}
